import React from 'react';

const Signin = React.lazy(() => import('../../modules/auth/Signin'));
const Signup = React.lazy(() => import('../../modules/auth/Signup'));
const SignupEnterprise = React.lazy(() => import('../../modules/auth/SignupEnterprise'));
const ForgotPassword = React.lazy(
  () => import('../../modules/auth/ForgetPassword')
);
const ConfirmSignupAwsCognito = React.lazy(
  () => import('../../modules/auth/Signup/ConfirmSignupAwsCognito')
);
const ResetPasswordAwsCognito = React.lazy(
  () => import('../../modules/auth/ForgetPassword/ResetPasswordAwsCognito')
);
const UpdatePassword = React.lazy(
  () => import('../../modules/auth/ForgetPassword/UpdatePassword')
);
const Register = React.lazy(
  () => import('apps/source/src/modules/provisionify/Register')
);

export const authRouteConfig = [
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/signup-enterprise',
    element: <SignupEnterprise />,
  },
  {
    path: '/forget-password',
    element: <ForgotPassword />,
  },
  {
    path: '/confirm-signup',
    element: <ConfirmSignupAwsCognito />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordAwsCognito />,
  },
  {
    path: '/update-password',
    element: <UpdatePassword />,
  },
  {
    path: '/registration/:key',
    element: <Register />,
  },
];
